<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="resetResource">
    <v-card flat>
      <v-card-title>
        {{ resourceExists ? "Update" : "Add" }} resource
        <v-spacer></v-spacer>
        <v-btn icon @click="resetResource">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        Create your own resource to train your members
      </v-card-subtitle>
      <v-card-text class="pb-0">
        <v-form ref="form" v-model="valid">
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="resource.title"
                label="Title"
                outlined
                maxlength="100"
                :rules="[$rules.required]"
                required
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="resource.author"
                label="Author"
                outlined
                maxlength="50"
                :rules="[$rules.required]"
                required
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="resource.url"
                label="Website"
                outlined
                :rules="[$rules.required]"
                required
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="resource.imageUrl"
                label="Image Url"
                outlined
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="resource.typeId"
                label="Type"
                :items="resource_types"
                outlined
                item-text="name"
                item-value="id"
                :rules="[$rules.required]"
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="resource.pulseCategoryId"
                label="Category"
                :items="categories"
                outlined
                item-text="name"
                item-value="id"
                clearable
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="resource.timeToConsume"
                label="Time to consume (minutes)"
                outlined
                :rules="[$rules.int]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-checkbox
                v-model="resource.isGlobal"
                label="Share with other CoreCounts companies?"
                hide-details
                class="mt-0 pt-0"
              >
              </v-checkbox>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn :loading="saving" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ResourceDialog",
  components: {},
  props: {
    resourceId: { type: String, default: "" }
  },
  data: () => ({
    dialog: false,
    valid: false,
    saving: false,
    loading: false,
    linkedCoreValue: null
  }),
  watch: {
    dialog: function(visible) {
      if (visible) {
        this.showDialog();
      }
    }
  },
  computed: {
    resourceExists() {
      return this.resource.id != null;
    },
    ...mapGetters({
      resource: "resource/resource",
      resource_types: "lookup/resource_types",
      categories: "pulse/categories"
    })
  },
  methods: {
    resetResource() {
      this.dialog = false;
    },
    showDialog(id) {
      this.dialog = true;
      this.loading = true;
      this.$store
        .dispatch("resource/getResource", id)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading this resource."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("resource/saveResource", this.resource)
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess("Resource saved.");
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving a resource."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
